<template>
  <div class="lab-flags-container w-full flex">
    <div
      class="lab-flag-item-open w-full flex flex-wrap mb-10"
      v-if="isOpen">

      <div class="w-full mb-4 modified-date">
        <label class="vs-input--label">Name</label>
        <vs-input
          class="w-full"
          v-model="flag.name"
        ></vs-input>
      </div>

      <div class="w-full mb-4 modified-date">
        <label class="vs-input--label">Correct Answer</label>
        <vs-input
          class="w-full"
          v-model="flag.correct_answer"
        ></vs-input>
      </div>

      <div class="w-full mb-4 modified-date">
        <label class="vs-input--label">Type</label>
        <vs-input
          class="w-full"
          v-model="flag.type"
          placeholder="short-text"
        ></vs-input>
      </div>

      <div class="w-full flex justify-between">
        <div class="flex items-end">
          <vs-button
            class="mr-5 save-button"
            color="primary"
            type="filled"
            icon-pack="feather"
            @click.stop="saveAndclose()"
          >
            Save
          </vs-button>
          <vs-button
            class="cancel-button"
            color="primary"
            type="border"
            icon-pack="feather"
            @click.stop="closeAndDiscard()"
          >
            Cancel
          </vs-button>
        </div>
      </div>
    </div>
    <div class="lab-flag-item-close w-full" v-else>
      <div class="flex justify-end">
        <div
          class="open-flag-btn w-full cursor-pointer p-4 border border-solid rounded border-grey-light"
          :style="{ fixed: true }"
          @click.stop="openFlag()"
        >
          <p><strong>{{ flag.name }}</strong>: {{ flag.correct_answer }}</p>
        </div>
        <div
          class="p-4 cursor-pointer delete-flag"
          @click.stop="deleteFlag(flag)"
          title="Delete flag"
        >
          <feather-icon
            icon="Trash2Icon"
            svgClasses="h-5 w-5 color-current text-danger"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      flags: [],
      openFlagIds: [],
      isOpen: false,
    }
  },
  props: {
    flag: {
      type: Object,
      required: true,
    },
    saveToApi: {
      type: Function,
      required: true,
    },
    deleteFlag: {
      type: Function,
      required: true,
    },
  },
  methods: {
    closeAndDiscard() {
      this.isOpen = false
    },
    openFlag() {
      this.isOpen = true
    },
    saveAndclose() {
      this.isOpen = false
      this.saveToApi()
    },
  },
}
</script>
